import { MapPin } from 'lucide-react';
import { Button } from '@ooh/ui/components/button';

export interface CatalogOpenOnMapActionProps {
  /** Translated action label, e.g. "Otwórz na mapie". */
  label: string;
  /** Invoked when the user activates the action (the parent performs navigation). */
  onOpen: () => void;
}

/**
 * Surfaces an "open on map" action next to the catalog search box when the
 * current search term parses as coordinates. It never navigates on its own — the
 * parent decides where to go — so the catalog's normal text search is untouched.
 */
export function CatalogOpenOnMapAction({ label, onOpen }: CatalogOpenOnMapActionProps) {
  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      onClick={onOpen}
      data-testid="catalog-open-on-map"
      className="gap-1.5"
    >
      <MapPin className="h-4 w-4" aria-hidden="true" />
      {label}
    </Button>
  );
}
